import { render, staticRenderFns } from "./videoTutorialPageDown.vue?vue&type=template&id=5588d7ac&scoped=true"
import script from "./videoTutorialPageDown.vue?vue&type=script&lang=js"
export * from "./videoTutorialPageDown.vue?vue&type=script&lang=js"
import style0 from "./videoTutorialPageDown.vue?vue&type=style&index=0&id=5588d7ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5588d7ac",
  null
  
)

export default component.exports